// src/utils/theme.js
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#00013A", // Dark blue
    },
    secondary: {
      main: "#A4D996", // Green
    },
    background: {
      default: "#080017", // Black
      paper: "#fbf3ff",  // White
    },
    text: {
      primary: "#D9D9D9", // White
      secondary: "#000", // Green
    },
  },
});

export default theme;
